// Centralized configuration for application URLs
// Change only this variable to switch between environments
const APP_ENVIRONMENT = "production"; // 'local' | 'development' | 'production'

// URLs per environment
const APP_URLS = {
  // Local environment: uses localhost with proxy
  local: {
    appUrl: "http://localhost:3000",
    keycloakUrl: "https://nlf-dev.api.jaduguard.com/auth",
    apiUrl: "https://nlf-dev.api.jaduguard.com",
    proxyUrl: "https://nlf-dev.api.jaduguard.com",
    baseUrl: "", // uses proxy configured in package.json
    n8nUrl: "https://nlf-dev-n8n.api.jaduguard.com",
  },

  // Development environment: deployed on nlf-dev.app.jaduguard.com
  development: {
    appUrl: "https://nlf-dev.app.jaduguard.com",
    keycloakUrl: "https://nlf-dev.api.jaduguard.com/auth",
    apiUrl: "https://nlf-dev.api.jaduguard.com",
    proxyUrl: "https://nlf-dev.api.jaduguard.com",
    baseUrl: "https://nlf-dev.api.jaduguard.com", // uses direct URL without proxy
    n8nUrl: "https://nlf-dev-n8n.api.jaduguard.com",
  },
  
  // Production environment: deployed on nl-funding.com
  production: {
    appUrl: "https://nl-funding.com",
    keycloakUrl: "https://api.nl-funding.com/auth",
    apiUrl: "https://api.nl-funding.com",
    proxyUrl: "https://api.nl-funding.com",
    baseUrl: "https://api.nl-funding.com", // use url for api in production
    n8nUrl: "https://nlf-dev-n8n.api.jaduguard.com",
  },
};

// Get configuration of the current environment
const currentConfig = APP_URLS[APP_ENVIRONMENT];

export const keycloakConfig = {
  url: currentConfig.keycloakUrl,
  realm: "nlf",
  clientId: "web_app",
  redirectUri: `${currentConfig.appUrl}/main-menu`,
};

// Configuration for native Keycloak login
export const keycloakInitOptions = {
  onLoad: "check-sso",
  silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
  checkLoginIframe: false,
  enableLogging: APP_ENVIRONMENT === "development",
  silentCheckSsoFallback: true,
  pkceMethod: "S256",
};

// Export URLs for usage in other files
export const appConfig = {
  appUrl: currentConfig.appUrl,
  keycloakUrl: currentConfig.keycloakUrl,
  apiUrl: currentConfig.apiUrl,
  proxyUrl: currentConfig.proxyUrl,
  baseUrl: currentConfig.baseUrl,
  n8nUrl: currentConfig.n8nUrl,
  environment: APP_ENVIRONMENT,
};

// IMPORTANT: In Keycloak Admin Console, ensure these are configured:
// - Valid Redirect URIs: ${currentConfig.appUrl}/*
// - Web Origins: ${currentConfig.appUrl}
// - Valid Post Logout Redirect URIs: ${currentConfig.appUrl} (optional, for logout redirect)
//
// ENVIRONMENT NOTES:
// - 'local': Local development on localhost:3000, uses proxy to avoid CORS
// - 'development': Application deployed at nlf-dev.app.jaduguard.com, uses direct URLs
// - 'production': Application deployed at nl-funding.com, uses direct URLs
